export default __webpack_public_path__ + "static/media/ic_yapp_approved.33aed5f1.svg";